import axios from 'axios'
import Cookies from 'js-cookie'
import get from 'lodash.get'
import md5 from 'md5'
import Router from '@/router'
import { Toast, Notify } from 'vant'

// let timeoutModal
let loadingToast

function getRandomToken() {
    let accessToken = ''
    const arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    for (let i = 0; i < 32; i++) {
        const pos = Math.round(Math.random() * (arr.length - 1))
        accessToken += arr[pos]
    }
    Cookies.set('mini-token', accessToken)
    return accessToken
}

// axios 配置
axios.defaults.timeout = 30 * 1000 // 60S
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.baseURL = process.env.VUE_APP_REQUEST_PROXY || process.env.VUE_APP_API_BASE_URL
// 异常拦截处理器
const errorHandler = (error) => {
    const status = get(error, 'response.status')
    /* eslint-disable*/
    switch (status) {
        case 400:
            error.message = '请求错误'
            break
        case 401:
            error.message = '未授权，请登录'
            break
        case 403:
            error.message = '拒绝访问'
            break
        case 404:
            error.message = `请求地址出错: ${error.response.config.url}`
            break
        case 408:
            error.message = '请求超时'
            break
        case 500:
            error.message = '服务器内部错误'
            break
        case 501:
            error.message = '服务未实现'
            break
        case 502:
            error.message = '网关错误'
            break
        case 503:
            error.message = '服务不可用'
            break
        case 504:
            error.message = '网关超时'
            break
        case 505:
            error.message = 'HTTP版本不受支持'
            break
        default:
            break
    }
    if (error.message.includes('timeout')) {
        Toast({
            message: '当前网络不可用，请稍后再试',
            position: 'bottom',
        })
    }
    return Promise.reject(error)
}

// request interceptor
axios.interceptors.request.use((config) => {
    if (!loadingToast) {
        loadingToast = Toast.loading({
            duration: 0,
            loadingType: 'spinner',
        })
    }
    let header = {
        'Content-Type': 'application/json'
    }

    if (false) {
        const timestamp = new Date().getTime()
        const token = '9725b7d5ca4a42e48d4e6a87b7706baf_app'
        const secretKey = '52672be6c67747888ff86e361ba39f01'
        const sign = md5(`${timestamp}_${secretKey}`)
        config.headers['timestamp'] = timestamp
        config.headers['token'] = token ? token : ''
        config.headers['sign'] = sign
    } else {
        const timestamp = new Date().getTime()
        let token1 = Cookies.get('token') || 'undefined'
        if (typeof token1 === undefined || typeof token1 === 'undefined' || token1 === 'undefined' || !token1.includes('_')) {
            token1 = ''
        }
        let secretKey1 = Cookies.get('secretKey') || 'undefined'
        if (typeof secretKey1 === undefined || typeof secretKey1 === 'undefined' || typeof secretKey1 === 'undefined' || !token1.includes('_')) {
            secretKey1 = ''
        }

        let token2 = Cookies.get('mini-token')
        // if (typeof token2 === undefined || typeof token2 === 'undefined' || token2 === 'undefined' || !token2.includes('merchant')) {
        //     token2 = ''
        // }
        let secretKey2 = Cookies.get('mini-secretKey')
        // if (typeof secretKey2 === undefined || typeof secretKey2 === 'undefined' || typeof secretKey2 === 'undefined' || !secretKey2.includes('merchant')) {
        //     secretKey2 = ''
        // }

        const token = token1 || token2 || getRandomToken()
        const secretKey = secretKey1 || secretKey2 || 'LTAI4G@2gQAJArV&U4mfcEbFoH'
        console.log('secretKey', secretKey)

        // const token = localStorage.getItem('token') || ''
        // const secretKey = localStorage.getItem('secretKey') || 'LTAI4G@2gQAJArV&U4mfcEbFoH'
        const sign = md5(`${timestamp}_${secretKey}`)
        config.headers['timestamp'] = timestamp
        config.headers['token'] = token
        config.headers['sign'] = sign
        config.headers['deviceType'] = 1
    }

    config.headers.common = header
    // console.log(8847,config)
    return config
}, errorHandler)
// response interceptor
axios.interceptors.response.use((response) => {
    let dataAxios = response.data
    if (typeof response.config === 'undefined') {
        dataAxios = response
    } else {
        if (!response.config.url.includes('/company/activity/useProduct')) {
            loadingToast.clear()
        }
        if (response.config.responseType && response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
            return Promise.resolve(response)
        }

    }
    // 这个状态码是和后端约定的
    const { code } = dataAxios
    // 根据 code 进行判断
    if (code === undefined) {
        return dataAxios
    } else {
        switch (code) {
            case 0:
                return dataAxios
            case -1:
                return dataAxios
            case 1001:
                Cookies.remove('mini-token')
                Cookies.remove('mini-secretKey')
                if (response.config.url.includes('api/activity/luckDraw/')) {
                    return dataAxios
                    // this.$eventBus.$emit('openLogin')
                } else if (response.config.url.includes('company/activity/useProduct')) {
                    return dataAxios
                    // this.$eventBus.$emit('openLogin')
                } else if (response.config.url.includes('company/activity/getCouponByRecordId')) {
                    return dataAxios
                    // this.$eventBus.$emit('openLogin')
                } else if (response.config.url.includes('company/activity/useProduct')) {
                    return dataAxios
                    // this.$eventBus.$emit('openLogin')
                } else if (response.config.url.includes('api/commonproblem')) {
                    return dataAxios
                    // this.$eventBus.$emit('openLogin')
                } else if (response.config.url.includes('api/activity/sign/config/list')) {
                    return dataAxios
                    // this.$eventBus.$emit('openLogin')
                } else if (response.config.url.includes('api/activity/sign/queryTodaySignInDay')) {
                    return dataAxios
                    // this.$eventBus.$emit('openLogin')
                } else {
                    const toPath = Router.app.$route.fullPath
                    // console.log(toPath)
                    Router.push(`/minilogin?redirect=${toPath}`)
                }
                // if (!timeoutModal) {
                //     timeoutModal = Dialog.confirm({
                //         title: '提示',
                //         message: '当前登录已过期，需重新登录',
                //     })
                //         .then(() => {
                //             Cookies.remove('mini-token')
                //             Cookies.remove('mini-secretKey')
                //             console.log(333)
                //             const toPath = Router.app.$route.fullPath
                //             console.log(toPath)
                //             Router.push(`/minilogin?redirect=${toPath}`)
                //             // on confirm
                //         })
                //         .catch(() => {
                //             Cookies.remove('mini-token')
                //             Cookies.remove('mini-secretKey')
                //             // window.location.reload()
                //             timeoutModal = null
                //             // on cancel
                //         });
                // }
                return Promise.reject(dataAxios)
            case 1011:
                const minitoken = getRandomToken()
                const minisecretKey = 'LTAI4G@2gQAJArV&U4mfcEbFoH'
                Cookies.set('mini-token', minitoken)
                Cookies.set('mini-secretKey', minisecretKey)
                const token = getRandomToken()
                const secretKey = 'LTAI4G@2gQAJArV&U4mfcEbFoH'
                Cookies.set('token', token)
                Cookies.set('secretKey', secretKey)
            default:
                let url = response.config.url
                if (url.includes('api/activity/luckDraw')) {
                    return dataAxios
                    // this.$eventBus.$emit('openLogin')
                } else if (url.includes('api/opens/activity')) {
                    return dataAxios
                    // this.$eventBus.$emit('openLogin')
                } else if (url.includes('company/activity/getCouponByRecordId')) {
                    return dataAxios
                } else if (url.includes('company/activity/useProduct')) {
                    return dataAxios
                } else {
                    Notify({
                        type: 'danger',
                        message: dataAxios.msg || dataAxios.data.msg || '请求错误'
                    })
                    return Promise.reject(dataAxios)
                }

        }
    }

}, errorHandler)

export default axios
